export function AuthDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.AUTH + '/:param')
        .setCustomActions({
            'saml_login': {
                method: 'POST',
                params: {param: 'saml_login'}
            },
            'sso_login': {
                method: 'POST',
                params: {param: 'sso_login'}
            },
            'saml_logout': {
                method: 'GET',
                params: {param: 'saml_logout'}
            },
            'sso_logout': {
                method: 'GET',
                params: {param: 'sso_logout'}
            },
            'set_config': {
                method: 'POST',
                notifications: true,
                params: {param: 'authconfig'}
            },
	        'set_auth_provider': {
		        method: 'POST',
		        notifications: true,
		        path:'/accessConfig'
	        },
	        'get_access_config': {
		        method: 'GET',
		        path: '/accessConfig'
	        },
            'get_config': {
                method: 'GET',
                params: {param: 'authconfig'}
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/auth_dao.js